import React from 'react';
import './photo-gallery.css';

const images = [
  '/images/gold.jpg',
 '/images/money.jpg',
  '/images/gold.jpg',
  // '/images/gallery3.jpg',
  // '/images/gallery4.jpg',
  // '/images/gallery5.jpg',
  // '/images/gallery6.jpg',
];

const PhotoGallery = () => {
  return (
    <div className="gallery-container">
      <h1>फोटो गॅलरी</h1>
      <div className="gallery-grid">
        {images.map((src, index) => (
          <div key={index} className="gallery-item">
            <img src={src} alt={`Gallery ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PhotoGallery;
